import React from "react";
import {ChatHeader} from "./chat.header";
import {ChatFailedSessionIcon} from "./icons";

export const ChatError = ({message, onClose, inlineMode, sidebarMode, isAdmin }) => (
    <div className={`sb-chat-container -v2 ${isAdmin ? 'sb-chat-container--admin' : ''} ${inlineMode ? 'sb-chat-container--inline' : ''} ${sidebarMode ? 'sb-chat-container--sidebar' : 'sb-chat-container--page'}`}>
        <div className="sb-chat-container__content">
            <ChatHeader onClose={onClose} inlineMode={inlineMode} sidebarMode={sidebarMode}/>

            <div className="sb-chat--failed-session">
                <ChatFailedSessionIcon />
                <div className={'sb-chat--failed-session_message'}>{message}</div>
            </div>

            <div className="sb-chat--footer sb-chat--footer_empty"></div>
        </div>
    </div>
);
